import { useState } from 'react';
import { MessageProps } from '~/shared/components';
import { ImportDialog, ImportDialogHandleFormat } from '~/shared/components/ui';
import { CaptionButton } from '~/shared/components/ui/Button';

export const UISampleFileImportDialogs = () => {
  const [isShow, setShow] = useState(false);
  const [isLoading, setLoading] = useState(false); // eslint-disable-line

  const handleExport: ImportDialogHandleFormat = {
    name: 'businessUnitManagement',
    headerColumns: [],
  };
  const handleImport: ImportDialogHandleFormat = {
    name: 'businessUnitManagement',
    headerColumns: [],
  };

  const headerLabelId: MessageProps = {
    prefixId: 'DIALOG_TITLE',
    id: 'FILE_IMPORT',
  };

  return (
    <div className="categories">
      <h3 id="dialog">ファイル取込ダイアログ</h3>
      <div className="input-line">
        <div className="item-group-100">
          <div className="w-33">
            <CaptionButton
              buttonType="basic"
              caption="確認する"
              name=""
              onClick={() => {
                setShow(true);
              }}
            />
            <ImportDialog
              isOpen={isShow}
              headerLabelId={headerLabelId}
              allIds={[]}
              ids={[]}
              preset={[]}
              isFileTypeSelectBox={true}
              userMasterCategoryName="A4000009"
              handleExport={handleExport}
              handleImport={handleImport}
              onChangeState={() => {
                setShow(false);
              }}
              onHandleSuccess={() => {
                setShow(false);
              }}
              onChangeLoadingState={setLoading}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
